import { render, staticRenderFns } from "./botPageLeft.vue?vue&type=template&id=108f98df&scoped=true&"
import script from "./botPageLeft.vue?vue&type=script&lang=js&"
export * from "./botPageLeft.vue?vue&type=script&lang=js&"
import style0 from "./botPageLeft.vue?vue&type=style&index=0&id=108f98df&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108f98df",
  null
  
)

export default component.exports